import { SESSION_ALL } from '@/components/activity/today-launches';
import type { AppRecord } from '@/lib/app-records';

/**
 * The séance of a launch (21/10/2026): its objects that still have an open
 * next action, in the list's order, starting at the object opened from Mon
 * travail and coming round to the ones before it. Fixed once computed, so an
 * object handled during the séance keeps its place.
 */
export const sessionOrder = (
  records: Array<Pick<AppRecord, 'id' | 'lastRunId' | 'archivedAt'>>,
  runId: string,
  open: Record<string, unknown>,
  currentId: string,
): string[] => {
  const ids = records
    .filter((record) => !record.archivedAt && (runId === SESSION_ALL || record.lastRunId === runId) && (record.id in open || record.id === currentId))
    .map((record) => record.id);
  const start = ids.indexOf(currentId);
  return start < 0 ? [currentId, ...ids] : [...ids.slice(start), ...ids.slice(0, start)];
};

/** The next object still to handle after the current one, or null when the launch is done. */
export const nextInSession = (order: string[], currentId: string, open: Record<string, unknown>): string | null => {
  const index = order.indexOf(currentId);
  const after = [...order.slice(index + 1), ...order.slice(0, Math.max(index, 0))];
  return after.find((id) => id in open) ?? null;
};
